/** The small uppercase caption over a field. */
export const FIELD_LABEL =
  'text-xs font-medium uppercase tracking-widest text-gray-500';

/** A rounded white card, as every section of the details pages sits in. */
export const CARD = 'rounded-3xl border border-gray-200 bg-white p-5 shadow-sm';
